<script setup>
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { useTemplateRef } from 'vue'
import Modal from '@/components/Functional/Modal.vue'
import BlockUserContent from '@/components/ModalContents/BlockUserContent.vue'
import { openUnblockModal, openReportModal, openBlockModal } from '@/helpers/modals.js'
import { useAuthStore } from '@/stores/auth.js'
import helpers from '@/helpers.js'

defineProps({
  user: {
    type: Object,
    required: true
  },
  updateUser: {
    type: Function,
    required: true
  },
  notAuthorizedCallback: {
    type: Function,
    required: false,
    default: null
  },
  source: {
    type: String,
    required: false,
    default: 'chat_header'
  },
  dotsClass: {
    type: String,
    required: false,
    default: 'text-gray-900 hover:text-gray-500'
  }
})

const open = ref(false)
const target = useTemplateRef('target')
const reportModal = useTemplateRef('reportModal')

onClickOutside(target, event => {
  open.value = false
})

const authStore = useAuthStore()

function toggleMenu () {
  if (authStore.isAuthenticated) {
    open.value = !open.value
  } else {
    helpers.showOnbordingOrSignUp()
  }
}
</script>

<template>
  <div class="relative inline-block text-left">
    <button
      id="options-menu"
      type="button"
      :class="dotsClass"
      class="rounded-full flex items-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
      @click="toggleMenu">
      <InlineSvg
        :src="require('@/assets/fontawesome/regular/ellipsis.svg')"
        class="w-5 h-5 shrink-0"/>
    </button>

    <transition name="fade-scale">
      <menu
        v-if="open"
        ref="target"
        class="absolute z-10 right-0 mt-2 py-1.5 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
        <li v-if="user.blocked">
          <button
            type="button"
            class="px-4 py-2 w-full text-sm text-left font-bold text-gray-700 hover:bg-gray-100"
            @click="openUnblockModal({ userId: user.userId, callback: updateUser })">
            {{ $t('creator.block.unblock_this_creator') }}
          </button>
        </li>

        <li v-else>
          <button
            type="button"
            class="px-4 py-2 w-full text-sm text-left font-bold text-gray-700 hover:bg-gray-100"
            @click="openBlockModal({ userId: user.userId, callback: updateUser })">
            {{ $t('creator.block.block_this_creator') }}
          </button>
        </li>

        <li>
          <button
            type="button"
            class="px-4 py-2 w-full text-sm text-left font-bold text-gray-700 hover:bg-gray-100"
            @click="openReportModal({ userId: user.userId, source: source })">
            {{ $t('creator.block.report_this_creator') }}
          </button>
        </li>
      </menu>
    </transition>

    <Modal
      v-slot="{ values, closeModal }"
      ref="reportModal"
      name="ReportUser">
      <BlockUserContent
        :heading="$t('creator.block.report_user')"
        :values="values"
        type="report"
        @close="closeModal()"/>
    </Modal>
  </div>
</template>